import { get } from 'lodash'
import {
  AVP_TYPE_OHAM,
  AVM_TYPE_NET_MED,
  AVM_TYPE_CARE_MED,
  AVM_TYPE_MED_BASE,
  AVM_TYPE_PATIENTS,
  AVM_TYPE_NAME,
  AVM_TYPE_OMUL,
} from '@shared/components/MedicalSearch/config/constants'

// AVM definition types
export const AVMGroupType = {
  OHAM: AVP_TYPE_OHAM,
  NET_MED: AVM_TYPE_NET_MED,
  CARE_MED: AVM_TYPE_CARE_MED,
  MED_BASE: AVM_TYPE_MED_BASE,
  PATIENTS: AVM_TYPE_PATIENTS,
  NAME: AVM_TYPE_NAME,
  OMUL: AVM_TYPE_OMUL,
}

export const MedAVMs = [AVMGroupType.CARE_MED, AVMGroupType.NET_MED]

export const ProductAVMtype = {
  OHAMProdukt: AVMGroupType.OHAM,
  ACSProdukt: AVMGroupType.CARE_MED,
  ANETProdukt: AVMGroupType.NET_MED,
  S2MUL1Produkt: AVMGroupType.MED_BASE,
  OMULProdukt: AVMGroupType.OMUL,
}

export const getAVMId = productId => ProductAVMtype[productId] || ''

export const getNetworkFromProduct = product => {
  if (product) {
    return [get(ProductAVMtype, product.productId, '')]
  }

  return MedAVMs
}

export const transformDoctorForProduct = doctor => {
  const {
    firstName,
    lastName,
    zsrNumber,
    email,
    phoneNumber,
    faxNumber,
    medicalOfficeName,
    medicalOfficeStatus,
    medicalOfficeNets,
    ...values
  } = doctor
  const { geo, ...address } = values

  return {
    firstName,
    lastName,
    zsrNumber,
    email,
    phoneNumber,
    faxNumber,
    medicalOfficeName,
    medicalOfficeStatus,
    medicalOfficeNets,
    address: {
      ...address,
      ...geo,
    },
  }
}
